import { dismissToast, useCurrentToast } from '../lib/toast';

const ICON: Record<string, string> = {
  success: 'M5 13l4 4L19 7',
  error: 'M6 18L18 6M6 6l12 12',
  warning: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  info: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
};
const BG: Record<string, string> = {
  success: 'bg-emerald-100 text-emerald-600',
  error: 'bg-red-100 text-red-600',
  warning: 'bg-amber-100 text-amber-600',
  info: 'bg-blue-100 text-blue-600',
};

export function ToastHost() {
  const toast = useCurrentToast();
  const visible = toast != null;
  const cls = 'fixed bottom-4 right-4 max-w-sm transform transition-all duration-300 z-[9999] ' +
    (visible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-20 opacity-0 pointer-events-none');
  return (
    <div class={cls}>
      <div class="bg-dark-800 border border-slate-700/50 rounded-lg shadow-lg p-4 flex items-start gap-3">
        <div class={'w-8 h-8 rounded-full flex items-center justify-center shrink-0 ' + (toast ? BG[toast.kind] : 'bg-slate-100')}>
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d={toast ? ICON[toast.kind] : ICON.info} />
          </svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-slate-100 truncate">{toast?.title || ''}</p>
          <p class="text-sm text-slate-400 mt-0.5">{toast?.message || ''}</p>
        </div>
        <button onClick={dismissToast} class="text-slate-500 hover:text-slate-200 p-1 -m-1 shrink-0" aria-label="Dismiss">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
    </div>
  );
}
